<template>
<div>
  <el-form ref="formBasic" :model="$socio.contatto.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">


<div class="row">
          <div class="col s4 m12"><img src="../assets/logo.png" style="height:80px;"/></div>
          <div class="col s8 m12"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
        </div>

        
    <div class="row">

<!--    
      <div class="col s12 m6">
      <el-form-item label="Cognome" prop="cognome">
        <el-input  v-model="$socio.contatto.row.cognome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nome" prop="nome">
        <el-input  v-model="$socio.contatto.row.nome"></el-input>
      </el-form-item>
      </div> 
-->
      <div class="col s12 m6">
      <el-form-item label="Email" prop="email">
        <el-input  v-model="$socio.contatto.row.email"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Reinserisci Email" prop="emailcheck"  class="is-required">
        <el-input  v-model="emailcheck"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 m6 clear">
      <el-form-item label="Data di nascita" prop="natoil" class="is-required">
        <el-date-picker v-model="$socio.contatto.row.natoil" type="date" placeholder="Indica la tua data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Sesso" prop="sesso">
        <el-select v-model="$socio.contatto.row.sesso"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Maschio" value="M" ></el-option>
          <el-option label="Femmina" value="F" ></el-option>
        </el-select>
      </el-form-item>
      </div> 
   

      <div class="col s12 m6">
      <el-form-item label="Nazione di nascita" prop="natonazione">
        <el-select v-model="$socio.contatto.row.natonazione"  filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nome" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>
   

      <div class="col s12 m6" v-if="$socio.contatto.row.natonazione=='ITA'">
      <el-form-item label="Provincia di nascita" prop="natoprovincia">
        <el-select v-model="$socio.contatto.row.natoprovincia" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.sigla" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6" v-if="$socio.contatto.row.natonazione=='ITA'">
      <el-form-item label="Città di nascita (ita)">
        <el-select v-model="$socio.contatto.row.natoa" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._comune" v-if="item.provincia==$socio.contatto.row.natoprovincia" :key="item.id" :label="item.nome" :value="item.nome" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      
      <div class="col s12" v-if="$socio.contatto.row.natonazione!='ITA'">
      <el-form-item label="Città di nascita" prop="natoa">
        <el-input  v-model="$socio.contatto.row.natoa"></el-input>
      </el-form-item>
      </div>


      <div class="col s12 m6">
      <el-form-item label="Codice Fiscale" prop="codicefiscale">
        <el-input  v-model="$socio.contatto.row.codicefiscale"></el-input>
      </el-form-item>
      </div>


      <div class="col s12">RESIDENZA</div>

      <div class="col s12">
      <el-form-item label="Address" prop="address">
        <el-input  v-model="$socio.contatto.row.address"></el-input>
      </el-form-item>
      </div>

      <div class="col s12 m6">
      <el-form-item label="CAP" prop="cap">
        <el-input  v-model="$socio.contatto.row.cap"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Provincia" prop="provincia">
        <el-select v-model="$socio.contatto.row.provincia"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.id" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div> 


      <div class="col s12 ">
      <el-form-item label="Città" prop="citta">
        <el-input  v-model="$socio.contatto.row.citta"></el-input>
      </el-form-item>
      </div>       

      <div class="col s12 m6">
      <el-form-item label="Cellulare" prop="cellulare">
        <el-input  v-model="$socio.contatto.row.cellulare"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Telefono" prop="telefono">
        <el-input  v-model="$socio.contatto.row.telefono"></el-input>
      </el-form-item>
      </div> 
<!--
      <div class="col s12">
      <el-form-item label="Country" prop="nazione">
        <el-select v-model="$socio.contatto.row.nazione" filterable placeholder="Choose from the list" style="width:100%;">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nomeeng" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>
      -->

      <div class="col s12">LAVORO</div>
      <div class="col s12">
      <el-form-item label="Struttura/Ente" prop="ente">
        <el-input  v-model="$socio.contatto.row.ente"></el-input>
      </el-form-item>
      </div>

      <div class="col s12">
      <el-form-item label="Unità Operativa" prop="unitaoperativa">
        <el-input  v-model="$socio.contatto.row.unitaoperativa"></el-input>
      </el-form-item>
      </div>

      <div class="col s12">
      <el-form-item label="Indirizzo" prop="workaddress">
        <el-input  v-model="$socio.contatto.row.workaddress"></el-input>
      </el-form-item>
      </div>

      <div class="col s12 m6">
      <el-form-item label="CAP" prop="workcap">
        <el-input  v-model="$socio.contatto.row.workcap"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 m6">
      <el-form-item label="Città" prop="workcitta">
        <el-input  v-model="$socio.contatto.row.workcitta"></el-input>
      </el-form-item>
      </div>   

      <div class="col s12 m6">
      <el-form-item label="FAX" prop="workfax">
        <el-input  v-model="$socio.contatto.row.workfax"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Telefono Lavoro" prop="worktel">
        <el-input  v-model="$socio.contatto.row.worktel"></el-input>
      </el-form-item>
      </div> 
      
          

    </div>


<!--
    <div class="title_h1 yo-color-primary" style="margin-top:30px;">ISTRUZIONE</div>

    <div class="row pad" style="margin-top:20px;">

      <div class="col s12 m6">
      <el-form-item label="Qualifica"  prop="categoriaprofessionale">
        <el-select v-model="$socio.contatto.row.categoriaprofessionale"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Medico chirurgo" :value="14" ></el-option>
          <el-option label="Medico med. generale (medico di famiglia)" :value="36" ></el-option>
          <el-option label="Pediatra di libera scelta" :value="37" ></el-option>
          <el-option label="Altro" :value="1" ></el-option>
        </el-select>
      </el-form-item>
      </div>
      <div class="col s12 m6">
      <el-form-item label="Anno di laurea" prop="annolaurea" >
        <el-date-picker v-model="$socio.contatto.row.annolaurea" type="year" placeholder="Scegli un anno" style="width:100%;" format="yyyy" value-format="yyyy"></el-date-picker>
      </el-form-item>
      </div>


      <div class="col s12">
      <el-form-item label="Specializzazione" prop="ruolo">
        <el-select v-model="$socio.contatto.row.ruolo"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="ospedaliero" :value="19" ></el-option>
          <el-option label="ospedaliero - borsista" :value="18" ></el-option>
          <el-option label="ospedaliero - direttore di u.o. complessa" :value="2" ></el-option>
          <el-option label="ospedaliero - direttore di u.o. semplice" :value="3" ></el-option>
          <el-option label="ospedaliero - dirigente" :value="7" ></el-option>
          <el-option label="ospedaliero - infermiere" :value="22" ></el-option>
          <el-option label="ospedaliero - pensionato" :value="14" ></el-option>
          <el-option label="ospedaliero - ricercatore" :value="17" ></el-option>
          <el-option label="ospedaliero - specializzando" :value="16" ></el-option>
          <el-option label="universitario" :value="20" ></el-option>
          <el-option label="universitario - borsista" :value="13" ></el-option>
          <el-option label="universitario - pensionato" :value="15" ></el-option>
          <el-option label="universitario - professore associato" :value="9" ></el-option>
          <el-option label="universitario - professore ordinario" :value="10" ></el-option>
          <el-option label="universitario - ricercatore" :value="11" ></el-option>
          <el-option label="universitario - specializzando" :value="12" ></el-option>
          <el-option label="pediatra di libera scelta" :value="21" ></el-option>
          <el-option label="medico emergenza territoriale" :value="25" ></el-option>
          <el-option label="libero professionista" :value="23" ></el-option>
          <el-option label="volontario" :value="24" ></el-option>
          <el-option label="altro" :value="26" ></el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12 m6 clear">
        <div class="col s4"><label for="allegato" class="el-form-item__label" style="width:100% !important">Curriculum Vitae</label></div>
        <upload class="col s8" 
        :value="$socio.contatto.row.cvitae" 
        v-on:change="val => $socio.contatto.row.cvitae=val" 
        v-on:success="cvitaeSuccess" 
        action="https://api.biomedia.net/201806/vue/upload/" 
        :savedir="'limmsy-biomedia.net/cvitae/'" 
        :previewurl="'https://limmsy-biomedia.net/cvitae/'" 
        extensions="pdf,doc,docx"></upload>
      </div>

    </div>
-->




    <div class="title_h1 yo-color-primary" style="margin-top:30px;">INFORMATIVA PRIVACY AI SENSI DELL’ ART. 13 DEL REGOLAMENTO EU n. 679/2016</div>
    
    <div class="row pad" style="margin-top:20px;">
<!--  {{$socio.si.row.authbasic}} » {{authcheck}} -->
    <div class="col s2 yo-align-right clear"> <el-form-item label="" class="no-label" prop="authbasic">
          <el-checkbox v-model="$socio.si.row.authbasic" :true-label="authcheck" false-label="" disabled></el-checkbox>
          </el-form-item>
        </div>
        <div class="col s10" style="padding-bottom:20px;padding-top:10px;">
          Si chiede di prendere visione dell' <a :href="'https://limmsy.biomedia.net/privacy-simgeped.pdf?'+$teras.random()" target="_blank" style="color:red;font-weight:bold;">informativa privacy</a> dei Soci della SIMGEPED. 
        </div>
<!--
        <div class="col s12 m10 offset-m2">
        Si prega di prestare eventuale consenso facoltativo:
        </div>
        
        <div class="col s2 yo-align-right clear"> <el-form-item label="" class="no-label" prop="authcommercial">
          <el-checkbox v-model="$socio.si.row.authcommercial" :true-label="authcheck" false-label=""></el-checkbox>
          </el-form-item>
        </div>
        <div class="col s10" style="padding-bottom:20px;padding-top:10px;">
          Per il trattamento dei dati personali al fine di un eventuale invio di materiale informativo da parte di altre associazioni e/o altri soggetti giuridici aventi interessi comuni con la SIMGEPED.
        </div>
-->

    </div>









    









  

    <div class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
         <div class="col s12 m3">
         <el-button style="width:100%;"  @click="$router.push('/home')">Indietro</el-button>
         </div> 
         <div class="col s12 m4 offset-m5">
         <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva</el-button>
         </div>
      </div>

  </el-form>
</div>
</template>

<script>
import upload from './Yo-upload.vue'
export default {
  name: 'contatto-edit',
  components: {
    upload
  },
  created () {
    this.$teras.page.title = (this.$socio.contatto.row.id>0) ? 'Modifica Contatto '+this.$socio.contatto.row.id : 'Nuovo Contatto'


    this.$socio.si.row.authbasic = this.$moment().format('YYYY-MM-DD')
    if(this.$socio.si.row.authcommercial!='0000-00-00')
      this.$socio.si.row.authcommercial = this.$moment().format('YYYY-MM-DD')
    if(this.$socio.si.row.authmaterial!='0000-00-00')
      this.$socio.si.row.authmaterial = this.$moment().format('YYYY-MM-DD')

  },
  mounted() {
    setTimeout(() => { 
      this.$socio.si.row.authbasic = this.$moment().format('YYYY-MM-DD')
    if(this.$socio.si.row.authcommercial!='0000-00-00')
      this.$socio.si.row.authcommercial = this.$moment().format('YYYY-MM-DD')
    if(this.$socio.si.row.authmaterial!='0000-00-00')
      this.$socio.si.row.authmaterial = this.$moment().format('YYYY-MM-DD')
    }, 2000)
  },
  beforeDestroy () {
  },
  data() {
    return {
      emailcheck:'',
      authcheck: this.$moment().format('YYYY-MM-DD'),
      checkEmail: function (rule, value, callback)  {
       console.log(this.emailcheck)
       if(typeof value !='undefined')
        if (value.toString()!=this.$socio.contatto.email) {
          return callback(new Error('L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'));
        }else{
          callback();
        }
      }
    }
  },
  methods: {
    onChange(editor, content){
      console.log(".................................................................................:"+editor)
      //this.form.note = editor
    },
    cvitaeSuccess() {
      //this.doUpdate()
      this.$notify.success({type: 'info',message: 'Curriculum Vitae allegato correttamente', duration:5000})    
        
    },
    onCancel() {
        this.$router.go(-1)
    },
    onSubmit: async function() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {      
          this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })


          var errore = 'no-error'

          if(errore == 'no-error' && this.$socio.contatto.row.email != this.emailcheck)
            errore='L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'

          if(errore == 'no-error' && this.$socio.si.row.authbasic != this.authcheck)
            errore='Bisogna accettare la privacy!'
            
          if(errore == 'no-error' && (this.$socio.contatto.row.natodata=='' || parseInt(this.$moment(this.$socio.contatto.row.natodata).toNow('yy',true))<18))
            errore='Bisogna essere maggiorenni!'
            
          if(errore == 'no-error' && (this.$socio.contatto.row.natoa==''))
            errore='La città di nascita è obbligatoria'

          var emailCHeck = await this.$socio.checkEmail(this.$socio.contatto.row.email,this.$socio.contatto.row.id)
          if(errore == 'no-error' && !emailCHeck)
            errore='L\'indirizzo email risulta già tra i nostri soci, la preghiamo di usarne uno diverso o contattare la segreteria!'

          /* eliminato fino al 27 maggio 2021
          if(errore == 'no-error' && this.$socio.contatto.row.cvitae.length < 5)
            errore='Bisogna allegare il proprio curriculum vitae!'
          */
         
          if(errore != 'no-error'){
            this.loading.close()
            window.scrollTo(0,0);
            this.$notify.error({title: 'Errore',message: errore});
          }else{
            await this.$socio.contatto.save()
            await this.$socio.si.save()
            this.loading.close()
            this.$router.push('/home/')
          }






          
          
        } else {
          window.scrollTo(0,0);
          this.$notify.error({title: 'Errore',message: 'Non tutti i dati sono stati inseriti in maniera corretta, la preghiamo di verificare!'});
          return false
        }
      })
    }

  },
  computed: {
     rules:function() {
      var rulesNow = {
        note: [
          { required: true, message: 'Le note ledevi scrivere' }
        ],
        email: [
          { required: true, message: 'L\'indirizzo email è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email corretto', trigger: 'blur,change' }
        ],
        voce: [
          { required: true, message: 'Il tipo di voce è obbligatorio'}
        ],
        giorno: [
          { required: true, message: 'La data è obbligatoria'}
        ] ,
        codicefiscale: [
          { required: true, message: 'Il codicefiscale è obbligatoria'}
        ],
        address: [
          { required: true, message: 'L\'indirizzo di residenza è obbligatorio', trigger: 'blur' }
        ],
        cap: [
          { required: true, message: 'Il cap di residenza è obbligatorio', trigger: 'blur' }
        ],
        provincia: [
          { required: true, message: 'La provincia di residenza è obbligatoria', trigger: 'blur' }
        ],
        citta: [
          { required: true, message: 'La città di residenza è obbligatoria', trigger: 'blur' }
        ],
        natoa: [
          { required: true, message: 'La città di nascita è obbligatoria' }
        ],
        natonazione: [
          { required: true, message: 'La nazione di nascita è obbligatoria' }
        ],
        natoprovincia: [
          { required: this.$socio.contatto.row.natonazione=='ITA', message: 'La provincia di nascita è obbligatoria' }
        ]  ,
        categoriaprofessionale: [
          { required: true, message: 'La qualifica è obbligatoria', trigger: 'blur' }
        ],
        ruolo: [
          { required: true, message: 'La specializzazione è obbligatoria', trigger: 'blur' }
        ],
        annolaurea: [
          { required: true, message: 'L\'anno di laurea è obbligatorio', trigger: 'blur' }
        ],
        ente: [
          { required: true, message: 'Il proprio ente è obbligatorio', trigger: 'blur' }
        ],
        workaddress: [
          { required: true, message: 'L\'indirizzo di lavoro è obbligatorio', trigger: 'blur' }
        ],
        workcap: [
          { required: true, message: 'Il cap di lavoro è obbligatorio', trigger: 'blur' }
        ],
        workpr: [
          { required: true, message: 'La provincia di lavoro è obbligatoria', trigger: 'blur' }
        ],
        workcitta: [
          { required: true, message: 'La città di lavoro è obbligatoria', trigger: 'blur' }
        ]    
      }
      return rulesNow
    }
  }
}
</script>
<style>

</style>